import { useCallback } from 'react';

import { AgeGroup, Domain, Format, TeacherType } from '@sayyesschool/common/entities/common';
import { EnrollmentType } from '@sayyesschool/common/entities/enrollment';
import { ageOptions, domainOptions, enrollmentTypeOptions, formatOptions, teacherOptions } from '@sayyesschool/frontend/features/packs';
import { useFormData } from '@sayyesschool/frontend/hooks/form';
import { Form } from '@sayyesschool/frontend/ui-components';

const defaultPack = {
    age: AgeGroup.Adults,
    domain: Domain.General,
    format: Format.Online,
    enrollmentType: EnrollmentType.Individual,
    teacherType: TeacherType.Russian,
    numberOfLessons: 4,
    lessonPrice: 0,
    lessonDuration: 60,
    description: ''
};

export default function PackForm({ pack = {}, onSubmit, ...props }) {
    const { data, handleChange } = useFormData({
        ...defaultPack,
        ...pack
    });

    const handleSubmit = useCallback(() => {
        onSubmit(data);
    }, [data]);

    return (
        <Form
            className="PackForm"
            onSubmit={handleSubmit}
            {...props}
        >
            <Form.Select
                label="Возраст"
                name="age"
                value={data.age}
                options={ageOptions}
                fluid
                required
                onChange={handleChange}
            />

            <Form.Select
                label="Направление"
                name="domain"
                value={data.domain}
                options={domainOptions}
                fluid
                required
                onChange={handleChange}
            />

            <Form.Select
                label="Формат"
                name="format"
                value={data.format}
                options={formatOptions}
                fluid
                required
                onChange={handleChange}
            />

            <Form.Select
                label="Тип обучения"
                name="enrollmentType"
                value={data.enrollmentType}
                options={enrollmentTypeOptions}
                fluid
                required
                onChange={handleChange}
            />

            <Form.Select
                label="Тип преподавателя"
                name="teacherType"
                value={data.teacherType}
                options={teacherOptions}
                fluid
                required
                onChange={handleChange}
            />

            <Form.Input
                type="number"
                name="numberOfLessons"
                value={data.numberOfLessons}
                label="Кол-во уроков"
                fluid
                onChange={handleChange}
            />

            <Form.Input
                type="number"
                name="lessonPrice"
                value={data.lessonPrice}
                label="Стоимость урока, руб."
                fluid
                onChange={handleChange}
            />

            <Form.Input
                type="number"
                name="lessonDuration"
                value={data.lessonDuration}
                label="Продолжительность урока, мин."
                fluid
                onChange={handleChange}
            />

            <Form.Textarea
                name="description"
                value={data.description}
                label="Описание"
                fluid
                onChange={handleChange}
            />
        </Form>
    );
}